"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _breakpoints = require("../../utils/breakpoints");
function getFallbackImage(props) {
  var breakpoint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'xl';
  var currentBreakpoint = _breakpoints.breakpoints.indexOf(breakpoint);
  var imageObj = props[breakpoint];
  var nextBreakpoint = _breakpoints.breakpoints[currentBreakpoint + 1];
  if (imageObj) return imageObj; // If no image object found for current breakpoint try next size up

  return getFallbackImage(props, nextBreakpoint);
}
var _default = getFallbackImage;
exports["default"] = _default;